import React from "react";
import {
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    DrawerHeader,
    DrawerFooter,
    DrawerBody,
    Button,
    Text
} from "@chakra-ui/react";
import ReviewReader from "../products/analyze/ReviewReader";
import {useQuery, gql} from "@apollo/client";

const queryProductIdsFromProductFamily = gql`query QueryProductIdsFromProductFamily($family: String = "") {
  products(where: {product_family: {_eq: $family}}) {
    product_platform_id
  }
}
`
export default function AspectReviewsDrawer({
                                                btnRef,
                                                isOpen,
                                                onOpen,
                                                onClose,
                                                sentimentClicked,
                                                productFamilyClicked,
                                                selectedAspect
                                            }) {
    let {loading, error, data} = useQuery(queryProductIdsFromProductFamily,
        {
            variables: {"family": productFamilyClicked},
        })
    if (loading) return <></>;
    if (error) {
        console.log("error", error)
        return <></>
    }
    console.log(data)
    const productIds = data.products.map(x => x.product_platform_id)
    return (
        <Drawer
            isOpen={isOpen}
            placement='right'
            onClose={onClose}
            finalFocusRef={btnRef}
            size={'lg'}
        >
            <DrawerOverlay/>
            <DrawerContent>
                <DrawerCloseButton/>
                <DrawerHeader>{productFamilyClicked}</DrawerHeader>

                <DrawerBody>
                    <Text>{sentimentClicked.charAt(0).toUpperCase() + sentimentClicked.slice(1)} reviews
                        for {selectedAspect}</Text>
                    <ReviewReader renderReviews={isOpen} product_ids={productIds} aspect={selectedAspect}
                                  sentiment={sentimentClicked}/>
                </DrawerBody>

                <DrawerFooter>
                    <Button variant='outline' mr={3} onClick={onClose}>
                        OK
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}